<template>
  <div>
    <div
      class="rounded p-2 mb-3 flex-col items-start justify-start shadow-md"
      :class="{
        'bg-yellow-100 border border-yellow-100': started && !ended
      }">
      <div class="w-full">
        <div class="text-xs font-medium mb-2">
          {{ started_at | moment('D MMM YYYY') }} - {{ ended_at | moment('D MMM YYYY') }}
        </div>
        <div class="flex items-center justify-between">
          <div class="flex-col items-start justify-start mr-2">
            <div class="leading-tight text-sm md:text-base font-semibold mb-2 uppercase">
              {{ name }}
            </div>
          </div>
          <div class="flex items-center justify-between">

            <template v-if="ranked && ended && userModule != null && userModule.ended_at != null && (id == 67 || id == 68 || id == 69 || id == 70 || id == 71 || id == 72 || id == 73 || id == 74)">
              <a
                :href="'/download-certificate-2022-smt-2-semifinal/' + userModule.id"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark" viewBox="0 0 16 16">
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/></svg>
              </a>
              &nbsp;
              <a
                :href="'/modules/' + id + '/key-solution'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 ml-3">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M218.1,167.17c0,13,0,25.6,4.1,37.4-43.1,50.6-156.9,184.3-167.5,194.5a20.17,20.17,0,0,0-6.7,15c0,8.5,5.2,16.7,9.6,21.3,6.6,6.9,34.8,33,40,28,15.4-15,18.5-19,24.8-25.2,9.5-9.3-1-28.3,2.3-36s6.8-9.2,12.5-10.4,15.8,2.9,23.7,3c8.3.1,12.8-3.4,19-9.2,5-4.6,8.6-8.9,8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7,6.2,34,5,22.8-15.5,24.1-21.6-11.7-21.8-9.7-30.7c.7-3,6.8-10,11.4-11s25,6.9,29.6,5.9c5.6-1.2,12.1-7.1,17.4-10.4,15.5,6.7,29.6,9.4,47.7,9.4,68.5,0,124-53.4,124-119.2S408.5,48,340,48,218.1,101.37,218.1,167.17ZM400,144a32,32,0,1,1-32-32A32,32,0,0,1,400,144Z" /></svg>
              </a>
            </template>
            <template v-if="ranked && ended && userModule != null && userModule.ended_at != null && (id == 59 || id == 60 || id == 61 || id == 62 || id == 63 || id == 64 || id == 65 || id == 66)">
              <a
                :href="'/download-certificate-2022-smt-2/' + userModule.id"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark" viewBox="0 0 16 16">
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/></svg>
              </a>
              &nbsp;
              <a
                :href="'/modules/' + id + '/key-solution'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 ml-3">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M218.1,167.17c0,13,0,25.6,4.1,37.4-43.1,50.6-156.9,184.3-167.5,194.5a20.17,20.17,0,0,0-6.7,15c0,8.5,5.2,16.7,9.6,21.3,6.6,6.9,34.8,33,40,28,15.4-15,18.5-19,24.8-25.2,9.5-9.3-1-28.3,2.3-36s6.8-9.2,12.5-10.4,15.8,2.9,23.7,3c8.3.1,12.8-3.4,19-9.2,5-4.6,8.6-8.9,8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7,6.2,34,5,22.8-15.5,24.1-21.6-11.7-21.8-9.7-30.7c.7-3,6.8-10,11.4-11s25,6.9,29.6,5.9c5.6-1.2,12.1-7.1,17.4-10.4,15.5,6.7,29.6,9.4,47.7,9.4,68.5,0,124-53.4,124-119.2S408.5,48,340,48,218.1,101.37,218.1,167.17ZM400,144a32,32,0,1,1-32-32A32,32,0,0,1,400,144Z" /></svg>
              </a>
              &nbsp;
              &nbsp;
              <a
                :href="'/modules/' + id + '/results'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M464,80H403.9a4,4,0,0,1-4-4c0-4.89,0-9,0-12.08A32,32,0,0,0,367.9,32h0l-223.79.26a32,32,0,0,0-31.94,31.93c0,3.23,0,7.22,0,11.81a4,4,0,0,1-4,4H48A16,16,0,0,0,32,96v16c0,54.53,30,112.45,76.52,125.35a7.82,7.82,0,0,1,5.55,5.9c5.77,26.89,23.52,52.5,51.41,73.61,20.91,15.83,45.85,27.5,68.27,32.48a8,8,0,0,1,6.25,7.8V444a4,4,0,0,1-4,4H176.45c-8.61,0-16,6.62-16.43,15.23A16,16,0,0,0,176,480H335.55c8.61,0,16-6.62,16.43-15.23A16,16,0,0,0,336,448H276a4,4,0,0,1-4-4V357.14a8,8,0,0,1,6.25-7.8c22.42-5,47.36-16.65,68.27-32.48,27.89-21.11,45.64-46.72,51.41-73.61a7.82,7.82,0,0,1,5.55-5.9C450,224.45,480,166.53,480,112V96A16,16,0,0,0,464,80ZM112,198.22a4,4,0,0,1-6,3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4,4,0,0,1,4-4.15h40a4,4,0,0,1,4,4C112.05,143.45,112,174.87,112,198.22Zm316.13-18.44c-4.39,6.52-11.87,15.78-22.13,21.89a4,4,0,0,1-6-3.46c0-26.51,0-56.63-.05-82.21a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4.15C447.16,139.11,440.05,162.09,428.14,179.78Z" /></svg>
              </a>
            </template>

            &nbsp;
            &nbsp;
            <template v-if="open_certificate && module_type == 'olimpiade' && (id == 121 || id == 122 || id == 123 || id == 124 || id == 125 || id == 126 || id == 127)">
              <a
                :href="'/certificate-download-semifinal/'+ certificate_id +'/' + userModule.id"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark" viewBox="0 0 16 16">
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/></svg>
              </a>
              &nbsp;
            </template>
            <template v-if="open_certificate && module_type == 'olimpiade' && (id != 121 && id != 122 && id != 123 && id != 124 && id != 125 && id != 126 && id != 127)">
              <a
                :href="'/certificate-download/'+ certificate_id +'/' + userModule.id"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark" viewBox="0 0 16 16">
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/></svg>
              </a>
              &nbsp;
            </template>
            <template v-if="ended && userModule != null && userModule.ended_at != null && open_review && module_type == 'olimpiade'">
              <a
                :href="'/modules/' + id + '/key-solution-olimpiade'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 ml-3">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M218.1,167.17c0,13,0,25.6,4.1,37.4-43.1,50.6-156.9,184.3-167.5,194.5a20.17,20.17,0,0,0-6.7,15c0,8.5,5.2,16.7,9.6,21.3,6.6,6.9,34.8,33,40,28,15.4-15,18.5-19,24.8-25.2,9.5-9.3-1-28.3,2.3-36s6.8-9.2,12.5-10.4,15.8,2.9,23.7,3c8.3.1,12.8-3.4,19-9.2,5-4.6,8.6-8.9,8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7,6.2,34,5,22.8-15.5,24.1-21.6-11.7-21.8-9.7-30.7c.7-3,6.8-10,11.4-11s25,6.9,29.6,5.9c5.6-1.2,12.1-7.1,17.4-10.4,15.5,6.7,29.6,9.4,47.7,9.4,68.5,0,124-53.4,124-119.2S408.5,48,340,48,218.1,101.37,218.1,167.17ZM400,144a32,32,0,1,1-32-32A32,32,0,0,1,400,144Z" /></svg>
              </a>
            </template>
            <template v-if="ranked && scored_at != null && module_type == 'tryout' && !free_version">
              <a
                :href="'/modules/' + id + '/rank'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M464,80H403.9a4,4,0,0,1-4-4c0-4.89,0-9,0-12.08A32,32,0,0,0,367.9,32h0l-223.79.26a32,32,0,0,0-31.94,31.93c0,3.23,0,7.22,0,11.81a4,4,0,0,1-4,4H48A16,16,0,0,0,32,96v16c0,54.53,30,112.45,76.52,125.35a7.82,7.82,0,0,1,5.55,5.9c5.77,26.89,23.52,52.5,51.41,73.61,20.91,15.83,45.85,27.5,68.27,32.48a8,8,0,0,1,6.25,7.8V444a4,4,0,0,1-4,4H176.45c-8.61,0-16,6.62-16.43,15.23A16,16,0,0,0,176,480H335.55c8.61,0,16-6.62,16.43-15.23A16,16,0,0,0,336,448H276a4,4,0,0,1-4-4V357.14a8,8,0,0,1,6.25-7.8c22.42-5,47.36-16.65,68.27-32.48,27.89-21.11,45.64-46.72,51.41-73.61a7.82,7.82,0,0,1,5.55-5.9C450,224.45,480,166.53,480,112V96A16,16,0,0,0,464,80ZM112,198.22a4,4,0,0,1-6,3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4,4,0,0,1,4-4.15h40a4,4,0,0,1,4,4C112.05,143.45,112,174.87,112,198.22Zm316.13-18.44c-4.39,6.52-11.87,15.78-22.13,21.89a4,4,0,0,1-6-3.46c0-26.51,0-56.63-.05-82.21a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4.15C447.16,139.11,440.05,162.09,428.14,179.78Z" /></svg>
              </a>
            </template>
            <template v-if="open_rank && module_type == 'olimpiade'">
              <a
                :href="'/olim/' + id + '/results'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M464,80H403.9a4,4,0,0,1-4-4c0-4.89,0-9,0-12.08A32,32,0,0,0,367.9,32h0l-223.79.26a32,32,0,0,0-31.94,31.93c0,3.23,0,7.22,0,11.81a4,4,0,0,1-4,4H48A16,16,0,0,0,32,96v16c0,54.53,30,112.45,76.52,125.35a7.82,7.82,0,0,1,5.55,5.9c5.77,26.89,23.52,52.5,51.41,73.61,20.91,15.83,45.85,27.5,68.27,32.48a8,8,0,0,1,6.25,7.8V444a4,4,0,0,1-4,4H176.45c-8.61,0-16,6.62-16.43,15.23A16,16,0,0,0,176,480H335.55c8.61,0,16-6.62,16.43-15.23A16,16,0,0,0,336,448H276a4,4,0,0,1-4-4V357.14a8,8,0,0,1,6.25-7.8c22.42-5,47.36-16.65,68.27-32.48,27.89-21.11,45.64-46.72,51.41-73.61a7.82,7.82,0,0,1,5.55-5.9C450,224.45,480,166.53,480,112V96A16,16,0,0,0,464,80ZM112,198.22a4,4,0,0,1-6,3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4,4,0,0,1,4-4.15h40a4,4,0,0,1,4,4C112.05,143.45,112,174.87,112,198.22Zm316.13-18.44c-4.39,6.52-11.87,15.78-22.13,21.89a4,4,0,0,1-6-3.46c0-26.51,0-56.63-.05-82.21a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4.15C447.16,139.11,440.05,162.09,428.14,179.78Z" /></svg>
              </a>
            </template>
            <template v-if="ranked && ended && userModule != null && userModule.ended_at != null && module_type == 'tryout' && !free_version">
              <a
                :href="'/modules/' + id + '/key-solution'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 ml-3">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M218.1,167.17c0,13,0,25.6,4.1,37.4-43.1,50.6-156.9,184.3-167.5,194.5a20.17,20.17,0,0,0-6.7,15c0,8.5,5.2,16.7,9.6,21.3,6.6,6.9,34.8,33,40,28,15.4-15,18.5-19,24.8-25.2,9.5-9.3-1-28.3,2.3-36s6.8-9.2,12.5-10.4,15.8,2.9,23.7,3c8.3.1,12.8-3.4,19-9.2,5-4.6,8.6-8.9,8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7,6.2,34,5,22.8-15.5,24.1-21.6-11.7-21.8-9.7-30.7c.7-3,6.8-10,11.4-11s25,6.9,29.6,5.9c5.6-1.2,12.1-7.1,17.4-10.4,15.5,6.7,29.6,9.4,47.7,9.4,68.5,0,124-53.4,124-119.2S408.5,48,340,48,218.1,101.37,218.1,167.17ZM400,144a32,32,0,1,1-32-32A32,32,0,0,1,400,144Z" /></svg>
              </a>
            </template>
            <template v-if="ranked && ended && userModule != null && userModule.ended_at != null && (id == 59 || id == 75 || id == 76 || id == 77 || id == 78 || id == 79 || id == 80 || id == 81)">
              &nbsp;
              &nbsp;
              <a
                :href="'/modules/' + id + '/results'"
                class="bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M464,80H403.9a4,4,0,0,1-4-4c0-4.89,0-9,0-12.08A32,32,0,0,0,367.9,32h0l-223.79.26a32,32,0,0,0-31.94,31.93c0,3.23,0,7.22,0,11.81a4,4,0,0,1-4,4H48A16,16,0,0,0,32,96v16c0,54.53,30,112.45,76.52,125.35a7.82,7.82,0,0,1,5.55,5.9c5.77,26.89,23.52,52.5,51.41,73.61,20.91,15.83,45.85,27.5,68.27,32.48a8,8,0,0,1,6.25,7.8V444a4,4,0,0,1-4,4H176.45c-8.61,0-16,6.62-16.43,15.23A16,16,0,0,0,176,480H335.55c8.61,0,16-6.62,16.43-15.23A16,16,0,0,0,336,448H276a4,4,0,0,1-4-4V357.14a8,8,0,0,1,6.25-7.8c22.42-5,47.36-16.65,68.27-32.48,27.89-21.11,45.64-46.72,51.41-73.61a7.82,7.82,0,0,1,5.55-5.9C450,224.45,480,166.53,480,112V96A16,16,0,0,0,464,80ZM112,198.22a4,4,0,0,1-6,3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4,4,0,0,1,4-4.15h40a4,4,0,0,1,4,4C112.05,143.45,112,174.87,112,198.22Zm316.13-18.44c-4.39,6.52-11.87,15.78-22.13,21.89a4,4,0,0,1-6-3.46c0-26.51,0-56.63-.05-82.21a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4.15C447.16,139.11,440.05,162.09,428.14,179.78Z" /></svg>
              </a>
            </template>
            <!-- ini button kerjakansoal -->
            <template v-if="started && (userModule == null || (userModule != null && userModule.ended_at == null))">
              <button
                class="start-exam bg-blue-600 text-white focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 ml-3"
                @click="openSponsorPopUp('/exam?' + queryString.stringify({module_id: id, exam_id, user_product_detail_id}))">
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"><path d="M133,440a35.37,35.37,0,0,1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37,7.46-27.53,19.46-34.33a35.13,35.13,0,0,1,35.77.45L399.12,225.48a36,36,0,0,1,0,61L151.23,434.88A35.5,35.5,0,0,1,133,440Z" /></svg>
              </button>
            </template>
          </div>
        </div>
        <div class="text-sm font-medium md:text-sm">
          {{ duration }} Menit - {{ total_question }} Soal
        </div>
      </div>
      <div
        v-if="userModule != null && userModule.ended_at == null"
        class="mt-2 text-sm font-medium md:text-sm flex flex-col items-start justify-start leading-5 w-full">
        <div>Waktu Mulai Mengerjakan</div>
        <div>{{ userModule.started_at | moment('D MMM - HH:mm') }}</div>
      </div>
      <div
        v-if="userModule != null && userModule.ended_at != null && (userModule.absolute_score != null || userModule.talent != null)"
        class="mt-2 text-sm font-medium md:text-sm flex flex-col items-start justify-start leading-5 w-full">
        <div class="w-full h-px border-t my-2" />
        <div
          v-if="ended_at != null"
          class="flex items-center justify-between w-full">
          <div>Diselesaikan Pada</div>
          <div>{{ userModule.ended_at | moment('D MMM - HH:mm') }}</div>
        </div>

        <div
          v-if="ranked"
          class="flex items-center justify-between w-full">
          <!-- <div>Benar · Salah · Kosong</div> -->
          <!-- <div>{{ userModule.correct_answer }} · {{ userModule.wrong_answer }} · {{ userModule.unanswered }}</div> -->
          <div>&nbsp;</div>
          <div>&nbsp;</div>
        </div>
        <div
          v-if="ranked"
          class="flex items-center justify-between w-full">
          <!-- <div>Persentase Benar</div> -->
          <!-- <div>{{ userModule.absolute_score }}%</div> -->
        </div>
        <template v-if="!ranked">
          <div class="flex items-center justify-between w-full">
            <div v-if="module_type_id == null">
              Bakat
            </div>
            <div v-else>
              Minat
            </div>
            <div>{{ userModule.talent }}</div>
          </div>
          <div class="flex flex-col items-start justify-start w-full space-y-2">
            <div v-if="module_type_id == null">
              Bidang Studi Yang Disarankan
            </div>
            <div v-else>
              Bidang Pekerjaan Yang Disarankan
            </div>
            <div
              v-if="userModule.study_field_1 != null"
              class="p-2 rounded bg-blue-100">
              {{ userModule.study_field_1 }}
            </div>
            <div
              v-if="userModule.study_field_2 != null"
              class="p-2 rounded bg-blue-100">
              {{ userModule.study_field_2 }}
            </div>
          </div>
        </template>
        <template v-if="userModule.relative_score != null">
          <div class="flex items-center justify-between w-full">
            <div>Skor Rata-Rata</div>
            <div>{{ Math.round(userModule.relative_score) }}</div>
          </div>
          <div class="flex items-center justify-between w-full">
            <div><span class="italic">Ranking</span> Nasional</div>
            <div>{{ userModule.relative_rank }}</div>
          </div>
          <button
            v-if="!detailOpen"
            class="active:outline-none mt-2 font-semibold text-blue-700 text-center w-full"
            @click="openDetail()">
            Lihat Detail
          </button>
          <template v-if="detailOpen">
            <div class="flex items-center justify-between w-full">
              <div>Total Peserta</div>
              <div>{{ total_ranked }}</div>
            </div>
            <div class="flex items-center justify-between w-full">
              <div>Perhitungan <span class="italic">Ranking</span></div>
              <div>{{ scored_at | moment('D MMM - HH:mm') }}</div>
            </div>
            <template v-if="!free_version">
              <div class="w-full h-px border-t my-2" />
              <div
                v-for="(score, i) in userModule.scores"
                :key="i"
                class="w-full mb-2">
                <div>{{ score.section.name }}</div>
                <div class="flex items-center justify-between w-full">
                  <div class="text-xs">
                    Jumlah Benar
                  </div>
                  <div>{{ score.total_correct }}</div>
                </div>
                <div class="flex items-center justify-between w-full">
                  <div class="text-xs">
                    Skor
                  </div>
                  <div>{{ Math.round(score.raw_score) }}</div>
                </div>
              </div>
            </template>
          </template>
          <button
            v-if="detailOpen"
            class="active:outline-none mt-2 font-semibold text-blue-700 text-center w-full"
            @click="closeDetail()">
            Tutup Detail
          </button>
        </template>
      </div>
      <div
        v-if="userModule != null && userModule.ended_at != null && (userModule.absolute_score == null && userModule.talent == null)"
        class="mt-2 text-sm font-medium md:text-sm flex flex-col items-start justify-start leading-5 w-full">
        <div class="w-full h-px border-t my-2" />
        <div
          v-if="ended_at != null"
          class="flex items-center justify-between w-full">
          <div>Status</div>
          <div>Dalam Antrian Koreksi</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id', 'name', 'started_at', 'started', 'ended_at', 'ended', 'duration', 'total_question', 'ranked', 'exam_id', 'users', 'user_product_detail_id', 'rank_file', 'scored_at', 'total_ranked', 'module_type_id', 'free_version', 'certificate_id', 'open_certificate', 'open_review','open_rank', 'module_type'],
  data() {
    return {
      queryString: window.queryString,
      detailOpen: false,
    };
  },
  computed: {
    completeUserData() {
      return this.$store.state.user == null ? false : this.$store.state.user.school != null;
    },
    userModule() {
      let filter = {
        user_product_detail_id: this.user_product_detail_id,
        exam_id: this.exam_id,
        module_id: this.id,
      }
      return this.$store.getters.userModuleByFilter(filter);
    }
  },
  mounted() {
  },
  methods: {
    openSponsorPopUp(tryoutUrl) {
      this.$store.commit('setTryoutUrl', tryoutUrl);
      this.$store.commit('setSponsorPopUpOpen', true);
    },
    openDetail() {
      this.detailOpen = true;
    },
    closeDetail() {
      this.detailOpen = false;
    }
  },
}
</script>
